module.exports = __webpack_public_path__ + "img/mood.cc49f362.svg";